module.exports = {
      id: "icon-center-grid-patients-usage",
      viewBox: "0 0 65 56",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-center-grid-patients",
      toString: function () {
        return this.url;
      }
    }